import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import countries from 'i18n-iso-countries';
import { FlagIcon } from '../../FlagIcon';
import enLocale from '../en.json';

const FlagRenderer: React.FC<CustomCellRendererProps> = ({ value }) => {
  const ISOAlpha3 = value;
  if (!ISOAlpha3) {
    return null;
  }

  return (
    <span>
      <FlagIcon code={ISOAlpha3} />
      {ISOAlpha3}
    </span>
  );
};

// This is fake data so the tests run.
const fakeTestLocaleData: countries.LocaleData = {
  countries: {},
  locale: 'en-us',
};

countries.registerLocale((enLocale as countries.LocaleData) || fakeTestLocaleData);

export const FlagColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: FlagRenderer,
  filter: 'agSetColumnFilter',
  tooltipValueGetter: params => {
    const ISOAlpha3 = params.data[(params.colDef as AdvancedColDef)?.field ?? ''];
    if (!ISOAlpha3) {
      return '';
    }

    if (ISOAlpha3 === 'EUR') {
      return 'European Union';
    } else {
      // TODO(johnwchadwick): This should be abstracted; it appears that the
      // country code is not strictly ISO alpha 3, as it includes 'EUR'
      // (which is obviously, not a country.)
      return countries.getName(ISOAlpha3, 'en') ?? ISOAlpha3 ?? '';
    }
  },
  ...colDef,
  ...absColDef(colDef),
});
